module.exports = __webpack_public_path__ + "ae4f90a3e1f27c74905d3b267244d03e.svg";